export default {
  pages: {
    products: {
      tape: {
        disclaimer3d: "*Not drawn to scale; lamination not shown.",
      },
    },
  },
  advantages: {
    title: "Core Strengths",
    content: "",
    list: [
      {
        title: "Core Technology",
        image: '/images/products/技术、工艺.jpg',
        url: "technology",
      },
      {
        title: "Self-Designed Equipment",
        image: '/images/products/自主装备.jpg',
        url: "selfequipped",
      },
      {
        title: "Quality Control",
        image: '/images/products/质量控制.png',
        url: "qualitycontrol",
      },
      {
        title: "Supply Capability",
        image: '/images/products/交付能力.jpg',
        url: "deliverycapability",
      },
    ],
    technology: {
      title: "Core Technology",
      introduction: {
        cases: [
          {
            title: "Ultra-fast Pulsed Laser Deposition Technology",
            content:
              "With years of R&D and production experience, Shanghai Superconductor has developed an ultra-fast superconducting film preparation technology using Pulsed Laser Deposition (PLD) coating method. This technology adopts unique process innovations such as high temperature in-situ stress control and multi-component synergistic optimization. It overcomes the traditional limitations of slow deposition speed and small sample space in PLD technology, achieving ultra-fast film formation while retaining the inherent advantages of PLD technology such as high coating quality and superior superconducting critical current performance.This technology addresses the low production efficiency of physical deposition methods, with characteristics including fast production speed, high yield and low cost, making it suitable for large-scale industrial production. After years of mass production testing, Shanghai Superconductor’s high-quality HTS tapes achieve deposition speeds of 100nm/s, more than three times faster than similar technologies.",
          },
          {
            title: "Rapid IBAD Coating Technology with Ultra-large Ion Sources",
            content:
              "Ion Beam Assisted Deposition (IBAD) technology is the key to prepare the buffer layer, which provides the cubic texture for the growth of superconducting layers. Based on years of R&D experience, Shanghai Superconductor has innovated and adopted an advanced ultra-large ion source fast IBAD coating technology. This technology increases ion beam density while making its energy and density more uniform, enhancing the coating efficiency of the buffer layer by more than three times. This provides a solid foundation for the subsequent preparation of high-performance, high-stability superconducting layers.",
          },
          {
            title: "Precision Customized Metal Substrate Technology ",
            content:
              "Shanghai Superconductor continues to invest in R&D, persistently exploring the path of domestic production of substrates. The company has successfully developed precision customized metal substrate technology, addressing the material supply bottleneck in the industry chain. The domestically produced substrates feature customizability, precise controllability of thickness, and nanoscale flatness, making them suitable for ultra-thin, ultra-hard, and other customized parameter requirements. The ultra-thin substrate has the thickness of 30μm, and the ultra-hard substrate has the tensile stress exceeding 700 MPa.",
          },
          {
            title: "Non-Contact Low-Temperature Rapid Cooling Continuous Lamination Technology",
            content:
              "The continuous lamination technology for superconducting tapes is the key process to ensure the stability of mechanical properties of superconducting tapes in actual application conditions, and is also the key indicator of the tapes' resistance to overcurrent impact. Shanghai Superconductor has developed a continuous lamination technology based on rapid tin slag processing, non-contact low-temperature rapid cooling, and passive automatic material collection. This technology involves various lamination materials including copper, brass, and stainless steel, addressing long-standing industry challenges such as stainless steel lamination, epoxy impregnation degradation, tape overcurrent burnout and tape cracking. As a result, the electrical and mechanical performance of 2G-HTS tapes has been significantly enhanced. The tapes can withstand industrial frequency impact currents of up to 2400A for 100ms without current degradation, and the tensile stress exceeds 700 MPa at 77K.",
          },
          {
            title: "Low-Temperature High-Field High-Performance Flux Pinning Technology",
            content:
              "Through systematic research and industrial improvements, Shanghai Superconductor has resolved the challenge of introducing effective pinning centers during rapid coating processes. This has effectively suppressed the magnetic field-induced current decay, significantly enhancing the product's low-temperature high-field performance and production capacity. The tapes have achieved a leading international performance level of 1600A (4.2K, 10T) in low-temperature high-field conditions. This lays a crucial core material foundation for the construction of applications such as superconducting magnets and large scientific devices, promoting the development of China's high-temperature superconducting strategic industry.",
          },
        ],
      },
    },
    selfequipped: {
      title: "Self-Designed Equipment",
      introduction: {
        cases: [
          {
            title: "Fully Self-Developed Production Equipment Technology",
            content:
              "After more than ten years of technological accumulation and hundreds of R&D improvements, Shanghai Superconductor has achieved complete independence in the intellectual properties of all production equipment, including pulsed laser deposition equipment and ion beam assisted deposition equipment. This has resulted in a perfect combination of high quality and high output, ensuring autonomous control over the production process. This breakthrough has ended foreign monopoly and filled the domestic gap in 2G-HTS tapes.",
          },
          {
            title: " Radiation-Assisted Conduction Heating Technology",
            content:
              "Efficient and stable heating technology is crucial for pulsed laser deposition equipment and is also a fundamental factor in the industrial production of HTS tapes. Drawing on years of production and R&D experience,Shanghai Superconductor has innovatively developed a radiation-assisted conduction heating technology suitable for roll-to-roll continuous tape production. This technology ensures that the tape can be rapidly heated to the target temperature during high-speed tape movement, while also forming a larger uniform temperature zone. This significantly improves heating efficiency and ensures the smooth progress of the coating process.",
          },
        ],
      },
    },
    qualitycontrol: {
      title: "Quality Control",
      introduction: {
        cases: [
          {
            title: "Process Inspection",
            content: `1）Atomic Force Microscope (AFM) is used to inspect the surface roughness of the substrate and isolation layer after electropolishing. 

2）X-ray diffractometer is used to measure the phase, crystallization, in-plane and out-of-plane texture, and stress of the coatings to ensure that each film layer meets the requirements of production process.  

3）Scanning Electron Microscope (SEM) is used to observe the surface morphology and the cutting edge of each coating layer. 

4）Probe-type profilometer is used to measure the thickness of each coating layer.`,
          },
          {
            title: "Final Inspection",
            content: `1）The current uniformity of the long superconducting tape is measured with the MCorder HTS tape critical current uniformity testing system. 

2）The PPMS comprehensive physical property measurement system is used to carry out low-temperature high-field performance test on the end samples of the long tape at 4.2K, 0-6T (full inspection) and 4.2K, 0-12T (sampling). 

3）The geometric dimensions (length, thickness, width) of the tape are measured using rewinders, micrometers, and vernier calipers respectively.`,
          },
        ],
      },
    },
    deliverycapability: {
      title: "Supply Capability",
      introduction: {
        content: "Shanghai Superconductor have Launched a comprehensive expansion plan to enhance production capacity and tape delivery capabilities in all aspects. The Phase I expansion project was successfully completed by the end of 2024, with an annual production capacity reaching 2,000km/yr. The Phase II expansion project is proceeding smoothly, with an expected annual production capacity of 4,000km upon completion. The Phase III expansion project has been filed and upon completion, Shanghai Superconductor's total production capacity will reach 20,000km/year.\n\nMoving forward, Shanghai Superconductor will continue to adhere to technological innovation, further enhance its supply capacity and product performance, and work closely with customers to drive breakthroughs and development in fusion energy as well as other superconducting application technologies."
      }
    },
  },
  performance: {
    title: "Performance",
    introduction: {
      cases: [
        {
          title: "Angle Dependence Test",
          content:
            "RRI tested the Ic value of our superconducting tapes at temperatures ranging from 15K to 90K, magnetic fields from 0T to 7T, and various angles. The test results indicate that Shanghai Superconductor’s tapes have significant advantages in high-field magnet applications.",
          pcontent: "Test time：2022.2",
        },
        {
          title: "Engineering Current Density: Technical University of Denmark",
          content:
            "The Technical University of Denmark tested the engineering current density of Shanghai Superconductor mainstream mass-produced superconducting tapes under extremely high magnetic fields and low temperatures. The results show that Shanghai Superconductor' s tapes  have high engineering current density and high mechanical strength, with JE(4.2K, 10T) up to 2000A/mm².",
          pcontent:
            "Source：A C Wulff, et al. Multifilamentary coated conductors for ultra-high magnetic field applications. Superconductor Science and Technology, 2021(34)",
        },
        {
          title: "Mechanical Properties Test: Substrate Uniaxial Tensile Test",
          content:
            "At room temperature, the yield strength of the substrate is tested by the tensile test method, achieving the yield strength of 1526 MPa.",
          pcontent: "Test time：2023.6",
        },
        {
          title: "Low-Temperature High-Field Performance Table",
        },
      ],
    },
  },
  service: {
    title: "Technical Service",
    introduction: {
      content: "While mass-producing high-temperature superconducting tapes in various specifications, Shanghai Superconductor has further expanded its service offerings to include customized solutions. These customized services are designed to better meet the unique needs of different customers in specific application scenarios. By precisely tailoring product specifications and performance parameters, we provide targeted superconducting tapes and supporting services for research, industrial, and other fields. We have a team of professional technicians who can offer full-process technical support to customers, from solution design to product delivery.",
      cases: [
        {
          title: "Customized High-Performance Superconducting Tapes",
          content: `Shanghai Superconductor is committed to pushing the limits of superconducting tape performance through continuous R&D efforts, maintaining its international leadership position. We are also gradually transforming customized products into mass-produced items to meet the needs of various application fields and to achieve research and development breakthroughs that set new world records.

            The performance of our current customized high-performance superconducting tapes under high magnetic field conditions reaches a current density of 3800 A/mm² (4.2 K, 12 T, tested by Japan's KEK Institute).`,
          pcontent:
            "Source: Superconducting properties of commercial REBCO-coated conductors with artificial pinning centers (Kiyosumi Tsuchiya et al 2021 Supercond. Sci. Technol. 34 105005)",
        },
        {
          title: "Customized Laser Slitting Superconducting Tapes",
          content:
            "Highly controllable laser slitting technology is an advanced slitting technology for HTS materials. It offers advantages such as high slitting precision, high slitting quality, high efficiency and controllability. This technology ensures the overall flatness and smoothness of the slit edges of the tape, effectively controlling the extension of slit cracks in HTS tapes.",
        },
        {
          title: "Customized Superconducting Tape of Copper-Silver Alloy Lamination",
          content:
            "Copper-silver alloy lamination technology is a method that uses copper-silver alloy to laminate superconducting tapes. It significantly enhances the tapes’ mechanical properties while slightly reducing the electrical performance of the tape.",
        },
      ],
    },
  },
  tape: {
    title: "2G-HTS Tapes",
    introduction: {
      title: "Introduction",
      content:
        "Shanghai Superconductor's ReBCO tapes, produced with physical vapor deposition, have world-leading low-temperature and high-field electrical properties, first-class self-field current density, excellent magnet winding performance, and extremely low AC loss. The tapes can be widely applied in various fields such as electric power, transportation, energy, medical treatment, and high-energy physics.",
      cases: [
        { title: "Core Structure" },
        { title: "Product Specification" },
      ],
    },
    disclaimer3d: "*Not drawn to scale; lamination not shown.",
  },
};
